var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._l((_vm.categoryPaths),function(cat){return _c('span',{key:cat.id,staticClass:"category"},[_c('span',[_vm._v(_vm._s(cat.description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }